export const FILTERS_PANEL_OVERFLOW_MODAL_WIDTH = '480px';
